import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { QuotationChangeStatusRequest, QuotationStatusMaster, QuotationSummaryUploaded } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { UploadedDocPopupComponent } from '../uploaded-doc-popup-quotation/uploaded-doc-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuotationSummaryService } from 'src/app/_Services/quotationNew/quotationsummary.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceSummaryService } from 'src/app/_Services/invoice/invoice-summary.service';
import { InvoiceChangeStatusRequest, InvoiceStatusMaster } from 'src/app/_Models/invoice/invoice-summary.model';
import { UploadedInvoiceDocPopupComponent } from '../uploaded-invoice-popup-quotation/uploaded-invoice-doc-popup.component';

@Component({
  selector: 'app-reject-popup',
  templateUrl: './reject-invoice-popup.component.html',
  styleUrls: ['./reject-invoice-popup.component.scss']
})
export class RejectInvoicePopupComponent implements OnInit, OnDestroy {

  @Input() data!: any;
  @Output() refreshdata = new EventEmitter<any>();
  public model: InvoiceChangeStatusRequest;
  public isLoading: boolean = false;
  componentDestroyed$: Subject<boolean> = new Subject();
  public reason: string = '';

  constructor(
    public modalService: NgbModal,
    public invoiceService: InvoiceSummaryService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.model = new InvoiceChangeStatusRequest();
    this.model.invoiceId = this.data.id;
    this.model.statusId = InvoiceStatusMaster.Rejected;
  }

  cancelClicked() {
    this.modalService.dismissAll();
    this.model.comment = this.reason;
    const modalRef = this.modalService.open(UploadedInvoiceDocPopupComponent, { centered: true, windowClass: 'document-popup-wrapper' , });
    modalRef.componentInstance.data = this.data;   // pass data to popup

    modalRef.componentInstance.setPdf(this.data.invoiceFileUrl);
  }

  saveRejectedQuotation() {
    // Validate reason is provided
    if (!this.reason || this.reason.trim() === '') {
      this.toastr.error(
        this.translate.instant('Please enter a reason for rejection')
      );
      return;
    }

    this.isLoading = true;
    this.model.comment = this.reason;
    this.invoiceService.updateInvoiceStatus(this.model)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (response) {
            if (response && response.result == 1) {
              // Show success toaster
              this.toastr.success(
                this.translate.instant('Invoice rejected successfully')
              );

              // Close modal and return success to refresh parent data
              // setTimeout(() => {
              //   this.modalService.dismissAll();
              //   // Refresh the page to show updated data
              //   window.location.reload();
              // }, 1500);
               this.refreshdata.emit();
            } else {
              this.toastr.error(
                this.translate.instant('Failed to reject invoice')
              );
            }
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error(
            this.translate.instant('An error occurred while rejecting the invoice')
          );
          console.error('Rejection error:', error);
        }
      );
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
